const confirmationToast = require("./confirmationToast");
import { triggerCartUpdate, refreshProductQtyMap } from "../components/cartUtil";
import { initializeQtyComponent } from "../utilities/globalUtilities";

const cache = {
    $body: $("body")
};

/**
 * Initialize the alternative product add2cart functionality
 * and to keep the vue qty initialized/updated when the product are added to basket
**/
const initAlternativeProductQty = () => {
    cache.$body.off("click", ".js-list-alternative-product-replace").on("click", ".js-list-alternative-product-replace", e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const productID = $this.attr("data-product-id");
        const url = $this.attr("data-url");
        const $alternativeModal = $("#alternative-product-modal");
        const $modalContainer = $alternativeModal.find(".modal-body");

        $modalContainer.spinner().start();

        if (!url) { return; }

        $.ajax({
            url: url,
            type: "POST",
            data: {
                alternativeID : productID
            },
            success: response => {
                if (typeof response == "object" && !response.success) {
                    $this.attr("disabled", "disabled");
                    $modalContainer.spinner().stop();
                } else {
                    confirmationToast.showConfirmationToast($this, null, 1, false);
                    refreshProductQtyMap(response.productQtyMap.items);
                    $(".minicart").trigger("count:update", response.cart);
                    triggerCartUpdate();
                    $alternativeModal.modal("hide");
                    $modalContainer.spinner().stop();
                }
            },
            error: () => {
                $alternativeModal.modal("hide");
                $modalContainer.spinner().stop();
                window.location.reload();
            }
        });
    });
};

/**
 * Update the visibility of the quantity components
 * @param {String} targets - A string with all the elements that are beign targeted for initialization, ex: "elem1, elem2, elem3"
**/
const updateVisibilityBasedOnState = targets => {
    const addToCartButtons = document.querySelectorAll(targets);

    addToCartButtons.forEach(btn => {
        const dataPid = btn ? btn.dataset.pid : null;
        if (dataPid === null) { return; }

        initializeQtyComponent(dataPid);
        triggerCartUpdate();
    });
};

/**
 * Initialize the specific quantity components, that are specified
*/
const initQtyComponents = () => {
    updateVisibilityBasedOnState(
        ".product-name-details--wrapper .js-add-to-cart" // targets the PDP main a2c vue component
    );

    // Initialize the vue qty component when they are initialized by adding the product to cart from the alternative modal
    initAlternativeProductQty();
};

export {
    initQtyComponents
};
